'use strict';

/**
 *
 * @name: apiPostService
 *
 */

function ApiPostService(
  $rootScope,
  $http,
  $q,
  $localStorage,
  translateDate
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function GET_POST(options) {

    var categoryId = options.categoryId;
    var seasonId = options.seasonId;
    var order = options.order;
    var page = options.page;
    var limit = options.limit;
    var lovedBy = options.lovedBy;
    var viewedBy = options.viewedBy;
    var isPublished = options.isPublished;
    var bookmarkedBy = options.bookmarkedBy;
    var contributedBy = options.contributedBy;
    var seriesId = options.seriesId;
    var playlistId = options.playlistId;
    var includeImages = options.includeImages;
    var includeComingSoon = options.includeComingSoon;
    var isDaily = options.isDaily;
    var sponsorId = options.sponsorId;
    var tagId = options.tagId;
    var nownessPicks = options.nownessPicks;
    var includeExclusivePicks = options.includeExclusivePicks;
    var isFeatured = options.isFeatured;
    var chronology = options.chronology;
    var slug = options.slug;
    var curated = options.curated;
    // console.log(isFeatured)
    var target = $rootScope.apiUrlNew +
      '/post?' +
      (categoryId ? '&CategoryId=' + categoryId : '') +
      (seasonId ? '&SeasonId=' + seasonId : '') +
      (order ? '&order=' + order : '') +
      (page ? '&page=' + page : '') +
      (limit ? '&limit=' + limit : '') +
      (lovedBy ? '&lovedBy=' + lovedBy : '') +
      (viewedBy ? '&viewedBy=' + viewedBy : '') +
      (typeof isPublished !== 'undefined' ? (isPublished === 'allOfThem' ? '' : '&isPublished=' + isPublished) : '&isPublished=true') +
      (bookmarkedBy ? '&bookmarkedBy=' + bookmarkedBy : '') +
      (contributedBy ? '&contributedBy=' + contributedBy : '') +
      (seriesId ? '&SeriesId=' + seriesId : '') +
      (playlistId ? '&PlaylistId=' + playlistId : '') +
      (includeImages ? '&includeImages=' + includeImages : '') +
      (includeComingSoon ? '&includeComingSoon=' + includeComingSoon : '') +
      (isDaily ? '&isDailyContent=' + isDaily : '') +
      (sponsorId ? '&SponsorId=' + sponsorId : '') +
      (tagId ? '&TagId=' + tagId : '') +
      (nownessPicks ? '&nownessPicks=true' : '') +
      (includeExclusivePicks ? '' : '') +
      (curated ? '&curated=true' : '') +
      (typeof isFeatured !== 'undefined' ? ('&featured=' + isFeatured + '') : '') +
      (isFeatured === true ? ('&featuredLanguage=zh-cn&featuredType=web') : '');

    if (chronology) {

      var _chronology = chronology
        .map(function(item, index) {
          return (index === 0 ? '&' : '') + item + '=' + slug + ((index < chronology.length - 1) ? '&' : '');
        })
        .join('');

      target = target + _chronology;
    }

    return $http
      .get(target)
      .success(function(response) {
        console.log(response)
        angular.forEach(response.items, function(item) {
          // CHINEESE 'TIMEZONE'
          item.publishDate = translateDate(item.publishDate);
        });
      });
  }

  function getPost(
    categoryId,
    order,
    page,
    limit,
    lovedBy,
    viewedBy,
    isPublished,
    bookmarkedBy,
    contributedBy,
    seriesId,
    playlistId,
    includeImages,
    includeComingSoon,
    isDaily,
    sponsorId,
    tagId,
    nownessPicks,
    chronology,
    slug,
    includeExclusivePicks,
    isFeatured) {

    var target = $rootScope.apiUrlNew +
      '/post?' +
      (categoryId ? '&CategoryId=' + categoryId : '') +
      (order ? '&order=' + order : '') +
      (page ? '&page=' + page : '') +
      (limit ? '&limit=' + limit : '') +
      (lovedBy ? '&lovedBy=' + lovedBy : '') +
      (viewedBy ? '&viewedBy=' + viewedBy : '') +
      (typeof isPublished !== 'undefined' ? (isPublished === 'allOfThem' ? '' : '&isPublished=' + isPublished) : '&isPublished=true') +
      (bookmarkedBy ? '&bookmarkedBy=' + bookmarkedBy : '') +
      (contributedBy ? '&contributedBy=' + contributedBy : '') +
      (seriesId ? '&SeriesId=' + seriesId : '') +
      (playlistId ? '&PlaylistId=' + playlistId : '') +
      (includeImages ? '&includeImages=' + includeImages : '') +
      (includeComingSoon ? '&includeComingSoon=' + includeComingSoon : '') +
      (isDaily ? '&isDailyContent=' + isDaily : '') +
      (sponsorId ? '&SponsorId=' + sponsorId : '') +
      (tagId ? '&TagId=' + tagId : '') +
      (nownessPicks ? '&nownessPicks=true' : '') +
      (includeExclusivePicks ? '' : '') +
      (typeof isFeatured !== 'undefined' ? ('&featured=' + isFeatured + '') : '');

    if (chronology) {

      var _chronology = chronology
        .map(function(item, index) {
          return (index === 0 ? '&' : '') + item + '=' + slug + ((index < chronology.length - 1) ? '&' : '');
        })
        .join('');

      target = target + _chronology;
    }

    return $http
      .get(target)
      .success(function(response) {

        angular.forEach(response.items, function(item) {
          // CHINEESE 'TIMEZONE'
          item.publishDate = translateDate(item.publishDate);
        });
      });
  }

  function getPostAsAdmin(params) {

    var target = [
      $rootScope.apiUrlNew,
      '/post?',
      (params.order ? 'order=' + params.order : ''),
      (params.limit ? '&limit=' + params.limit : ''),
      (params.minDate ? '&minPublishDate=' + params.minDate : ''),
      (params.maxDate ? '&maxPublishDate=' + params.maxDate : ''),
      (typeof params.translations !== 'undefined' ? '&translationRequired=' + params.translations : ''),
      (typeof params.isDaily !== 'undefined' ? '&isDailyContent=' + params.isDaily : ''),
      (typeof params.contributors !== 'undefined' ? '&includeContributors=' + params.contributors : ''),
      (typeof params.commingSoon !== 'undefined' ? '&IsComingSoon=' + params.commingSoon : ''),
      (typeof params.isPublished !== 'undefined' ? '&isPublished=' + params.isPublished : ''),
      (typeof params.standBy !== 'undefined' ? '&standBy=' + params.standBy : ''),
      (typeof params.exclusivePicks !== 'undefined' ? '&exclusivePicks=' + params.exclusivePicks : ''),
    ].join('');

    var options = {
      headers: {
        'x-Nowness-Cms-Request': true,
        'X-Nowness-Language': 'en-us,zh-cn,zh-hk',
        'Authorization': $localStorage.NownessAdmin.user.token
      }
    };

    return $q(function(resolve, reject) {

      $http
        .get(target, options)
        .success(function(response) {

          resolve(response);
        }).error(function(response) {

          reject(response);
        });
    });
  }

  function getPostBySlug(slug, password) {

    var target = $rootScope.apiUrlNew + '/post/getbyslug/' + slug;

    if (!password) {

      return $http
        .get(target)
        .success(function(response) {

          // CHINEESE 'TIMEZONE'
          response.publishDate = translateDate(response.publishDate);
        });
    }
    if (password) {

      var options = {
        headers: {
          'X-Nowness-Password': password
        }
      };

      return $http
        .get(target, options)
        .success(function(response) {

          // CHINEESE 'TIMEZONE'
          response.publishDate = translateDate(response.publishDate);
        });
    }
  }

  function getPostById(id, previewToken, isAdmin) {

    var options = {};

    if (isAdmin && $localStorage.NownessAdmin && $localStorage.NownessAdmin.user) {

      options.headers = {
        'x-Nowness-Cms-Request': true,
        'X-Nowness-Language': 'en-us,zh-cn,zh-hk',
        'Authorization': $localStorage.NownessAdmin.user.token
      };
    }

    var target = $rootScope.apiUrlNew + '/post/' + id + (previewToken ? '?previewToken=' + previewToken : '');

    return $http
      .get(target, options)
      .success(function(response) {
        // CHINEESE 'TIMEZONE'
        response.publishDate = translateDate(response.publishDate);
      });
  }

  function viewPost(postId) {

    var target = $rootScope.apiUrlNew + '/post/' + postId + '/view';

    return $http.post(target, {});
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    getPost: getPost,
    GET_POST: GET_POST,
    getPostAsAdmin: getPostAsAdmin,
    getPostById: getPostById,
    getPostBySlug: getPostBySlug,
    viewPost: viewPost
  };
}

export default ApiPostService;



// WEBPACK FOOTER //
// ./app/components/_api/post.service.js